var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSupportUser
    ? _c("div", { staticClass: "tile is-parent pl-1" }, [
        _c("section", { staticClass: "tile is-child box" }, [
          _vm._m(0),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("span", { staticClass: "subtitle" }, [
                  _vm._v("Repair Stage"),
                ]),
                _vm._l(_vm.repxStages, function (stage, key) {
                  return _c(
                    "div",
                    { key: key },
                    _vm._l(_vm.repxStageSettings[key], function (input, index) {
                      return _c("div", { key: index }, [
                        _c(
                          "div",
                          { staticClass: "pt-2" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(_vm._s(stage)),
                            ]),
                            _c("Multiselect", {
                              attrs: {
                                options: _vm.jobStagesAvailable,
                                "hide-selected": true,
                                multiple: true,
                                "close-on-select": false,
                                "clear-on-select": false,
                                "show-labels": false,
                                "preserve-search": true,
                                placeholder: "Please Select At one Job stage",
                                "track-by": "compositeKey",
                                label: "compositeName",
                              },
                              model: {
                                value: _vm.repxStageSettings[key][index],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.repxStageSettings[key],
                                    index,
                                    $$v
                                  )
                                },
                                expression: "repxStageSettings[key][index]",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  )
                }),
                _c("div", { staticClass: "buttons mt-5" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary tooltip",
                      attrs: { "data-tooltip": "Save" },
                      on: { click: _vm.updateRepxStagesSetting },
                    },
                    [_vm._m(1), _c("span", [_vm._v("Save")])]
                  ),
                ]),
              ],
              2
            ),
            _c("div", { staticClass: "column" }, [
              _c("h3", { staticClass: "subtitle" }, [
                _vm._v("Available Job Stages"),
              ]),
              _c(
                "ul",
                _vm._l(_vm.jobStagesAvailable, function (item) {
                  return _c("li", { key: item.compositeKey }, [
                    _c("span", { staticClass: "multiselect__tag mt-2" }, [
                      _vm._v(" " + _vm._s(item.compositeName) + " "),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
        _c(
          "div",
          {
            staticClass:
              "notification is-danger is-flex is-justify-content-center is-size-4",
            staticStyle: { width: "50%" },
          },
          [_vm._v(" You do not have permissions on this page ")]
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "subtitle" }, [_vm._v("RepX Stages Setting")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-content-save mdi-20px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }